module.exports = __webpack_public_path__ + "img/card-akord.cf8e2640.svg";